module.exports = __webpack_public_path__ + "img/icon-intro.139ca3e7.png";